export default __webpack_public_path__ + "static/media/trace-image-item.dfca4f3e.png";